export const getGreeting = (
  currentHour: number
): "morning" | "afternoon" | "evening" => {
  if (currentHour >= 0 && currentHour < 12) {
    return "morning";
  } else if (currentHour >= 12 && currentHour < 18) {
    return "afternoon";
  } else {
    return "evening";
  }
};

export const getPersonalizedGreeting = (
  t: (key: string) => string,
  firstName?: string
): string => {
  const now = new Date();
  const currentHour = now.getHours();
  const greetingType = getGreeting(currentHour);

  const greetingKey = `Greetings.${greetingType}`;
  const greeting = t(greetingKey);

  return firstName ? `${greeting}, ${firstName}` : greeting;
};
